<template>
	<!--TODO translations for props-->
	<div>
		<div v-if="showUploadedFile">
			<div v-if="localUpload.id" class="mb-3 font-weight-bold">
				<i class="far fa-file-pdf mr-2"></i>
				<a v-bind:href="uploadLink" target="_blank">
					{{ localUpload.filename }}
				</a>
			</div>
		</div>

		<div class="input-group">
			<label for="crop-upload" class="">{{ __("Upload new file:") }}</label>
			<input
				type="file"
				id="crop-upload"
				ref="file"
				v-bind:accept="accept"
				autocomplete="new-password"
				@change="pendingUpload = true"
				class="form-control-file mb-3"
			/>
			<div class="invalid-feedback">
				{{ __(validationMessage) }}
			</div>
		</div>
		<div
			class="form-required d-flex justify-content-between align-items-center"
		>
			<label class="mb-0 pr-2 pb-2">{{ __("Description") }}</label>

			<div class="flex-fill pr-2 pb-2">
				<select class="custom-select" v-model="labelOption">
					<option
						v-for="option in labelOptions"
						v-bind:value="option.id"
						:key="option.id"
					>
						{{ __(option.label) }}
					</option>
				</select>
			</div>
			<div class="flex-fill pr-2 pb-2" v-if="labelOption == null">
				<input
					type="text"
					class="form-control"
					:placeholder="__('Please insert description')"
					v-model="customLabel"
					required
				/>
			</div>
			<div class="pb-2">
				<button
					class="btn btn-primary"
					v-on:click.prevent="submitUpload()"
					:disabled="buttonLock"
				>
					{{ __("Upload") }}
				</button>
			</div>
			<div class="pb-2 pl-2" v-if="pendingUpload">
				<button class="btn btn-warning" v-on:click.prevent="cancelUpload()">
					{{ __("Cancel") }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		upload: {
			type: Object,
			required: false,
		},
		obj: {
			type: Object,
			required: false,
		},
		objKey: {
			type: String,
			required: false,
		},
		accept: {
			type: String,
			required: false,
			default: "application/pdf",
		},
		required: {
			type: Boolean,
			required: false,
			default: false,
		},
		defaultLabel: {
			type: String,
			required: false,
			default: "Conditions of purchase", //TODO
		},
		publicUpload: {
			type: Boolean,
			required: false,
			default: false,
		},
		showUploadedFile: {
			type: Boolean,
			required: false,
			default: true,
		},
		labelOptions: {
			type: Array,
			required: false,
			default() {
				return [
					{
						id: "Conditions of purchase",
						label: "Conditions of purchase",
					},
					{
						id: "Certificate",
						label: "Certificate",
					},
					{
						id: "Self declaration",
						label: "Self declaration",
					},
					{
						id: "Quality assurance agreement",
						label: "Quality assurance agreement",
					},
					{
						id: null,
						label: "Other ",
					},
				];
			},
		},
		threadId: {
			type: Number,
			required: false,
			default: null,
		},
	},
	data() {
		return {
			localUpload: this.upload || {},
			pendingUpload: null,
			validationMessage: "",
			buttonLock: false,
			endPoint: window.baseUrl + "/api/user_upload",
			labelOption: this.__(this.defaultLabel),
			customLabel: "",
		};
	},
	methods: {
		cancelUpload() {
			this.$refs.file.value = null;
			this.pendingUpload = false;
		},
		submitUpload() {
			let file = this.$refs.file.files[0],
				formData = new FormData(),
				that = this;

			if (!file) {
				alert(this.__("Please select a file to upload first!"));
				return false;
			}

			this.buttonLock = true;
			formData.append("label_id", this.labelOption);
			formData.append(
				"label",
				this.labelOption == null ? this.customLabel : null
			);
			formData.append("public", this.publicUpload);
			formData.append("thread_id", this.threadId);
			formData.append("file", file);
			axios
				.post(this.endPoint, formData, {
					headers: {
						"Content-Type": "multipart/form-data",
					},
				})
				.then(function (response) {
					console.log("SUCCESS!!", response);
					that.localUpload = response.data.data;
					that.cancelUpload();

					that.maybeUpdateObj();

					that.$emit("new-upload", that.localUpload);
				})
				.catch(function (response) {
					console.log("FAILURE!!", response);
					alert(this.__("Error! File upload not successful"));
				})
				.finally(function () {
					that.validationMessage = "";
					that.pendingUpload = false;
					that.buttonLock = false;
				});
		},
		maybeUpdateObj() {
			if (this.obj) {
				this.obj[this.objKey] = this.localUpload.id;
			}
		},
		checkIfUploadRequired() {
			if (this.required && !this.localUpload.id) {
				this.validationMessage = "File upload succesful!";
			} else {
				this.validationMessage = "";
			}
		},
	},
	watch: {
		pendingUpload: {
			handler() {
				this.checkIfUploadRequired();
			},
			immediate: true,
		},
		validationMessage: {
			handler() {
				this.$refs.file.setCustomValidity(this.validationMessage);
			},
		},
	},
	computed: {
		uploadLink() {
			let link = this.endPoint + "/" + this.localUpload.id + "/download";
			return link;
		},
	},
	created() {
		// we may have been passed an obj, where key contains the id of the
		// upload field we need to work with
		if (this.obj) {
			let endpoint = this.endPoint + "/" + this.obj[this.objKey],
				that = this;
			axios
				.get(endpoint)
				.then(function (response) {
					that.localUpload = response.data.data;
					that.checkIfUploadRequired();
				})
				.catch(function (response) {
					console.log("ERR", response);
					alert(this.__("Internal error (file upload)"));
				});
		}
	},
	mounted() {
		this.checkIfUploadRequired();
		this.$refs.file.setCustomValidity(this.validationMessage);
	},
};
</script>
